import { render, staticRenderFns } from "./SaleShow.vue?vue&type=template&id=b1abc86e&"
import script from "./SaleShow.vue?vue&type=script&lang=js&"
export * from "./SaleShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports